import { render } from "./walletProduct.vue?vue&type=template&id=451948a4&scoped=true&ts=true"
import script from "./walletProduct.vue?vue&type=script&lang=ts"
export * from "./walletProduct.vue?vue&type=script&lang=ts"

import "./walletProduct.vue?vue&type=style&index=0&id=451948a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451948a4"]])

export default __exports__